import React, { forwardRef } from 'react';
import { styled } from '@mui/material';

import { Box, Icon, Stack, Text } from 'shell/components';

const LineMarker = forwardRef((props, ref) => {
    return (
        <RootStack ref={ref} alignItems={'center'} {...props}>
            <TextStack alignItems={'center'} direction={'row'} spacing={1}>
                <Text color={'inherit'} variant={'p3'}>
                    Upcoming Tasks
                </Text>
                <CustomIcon kind={'arrowRight'} />
            </TextStack>
            <ArrowBox />
            <LineBox />
        </RootStack>
    );
});

const RootStack = styled(Stack)(() => {
    return {
        position: 'relative',
        zIndex: 1,
        marginLeft: '-3.75rem',
        marginRight: '-4.25rem',
        width: '7.5rem',
        minHeight: '100%',
    };
});

const TextStack = styled(Stack)(({ theme }) => {
    return {
        borderRadius: '4px',
        padding: theme.spacing(1, 2),
        background: theme.palette.ensightful.primary[500],
        color: theme.palette.ensightful.shades[0],
    };
});

const CustomIcon = styled(Icon)(() => {
    return {
        color: 'inherit',
    };
});

const ArrowBox = styled(Box)(({ theme }) => {
    return {
        position: 'absolute',
        top: '1.5rem',
        borderTop: `8px solid ${theme.palette.ensightful.primary[500]}`,
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
    };
});

const LineBox = styled(Box)(({ theme }) => {
    return {
        width: '2px',
        minHeight: 'calc(100% - 1.5rem)',
        background: theme.palette.ensightful.primary[500],
    };
});

export default LineMarker;
